const PdfGenerator = {
  getColumns: (data) => {
    return data.map((entry) => {
      return {
        columns: [
          {
            text: entry.key,
            style: "label",
          },
          {
            text: entry.value,
            style: "value",
          },
        ],
      };
    });
  },
  generate: (info, contactInfo, additionalContent, messages) => {
    const pdfData = {
      content: [
        {
          columns: [
            {
              image:
                "data:image/png;base64,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",
              width: 80,
            },
          ],
        },
        {
          style: "section",
          table: {
            widths: "*",
            body: [
              [
                {
                  text: messages.step1,
                  style: "sectionHeader",
                },
              ],
            ],
          },
          layout: "noBorders",
        },
        ...PdfGenerator.getColumns(info),
        {
          style: "section",
          table: {
            widths: "*",
            body: [
              [
                {
                  text: messages.restitutionFormFooterDetail,
                  style: "sectionHeader",
                },
              ],
            ],
          },
          layout: "noBorders",
        },
        ...PdfGenerator.getColumns(additionalContent),
      ],

      styles: {
        header: {
          fontSize: 16,
          bold: true,
          margin: [20, 1],
        },
        sectionHeader: {
          fontSize: 15,
          bold: true,
        },
        section: {
          margin: [0, 15, 0, 5],
          fillColor: "#E6E6E6",
        },
        label: {
          fontSize: 14,
          width: "*",
          margin: [0, 4],
        },
        value: {
          fontSize: 14,
          bold: true,
          width: "*",
          margin: [0, 4],
        },
      },
    };
    return pdfData;
  },
};

export default PdfGenerator;
